import { render, staticRenderFns } from "./KunMingPayComp.vue?vue&type=template&id=5a789e18&scoped=true&"
import script from "./KunMingPayComp.vue?vue&type=script&lang=js&"
export * from "./KunMingPayComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a789e18",
  null
  
)

export default component.exports